import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var CheckIcon = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#52BD94" : _ref$color,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _jsx("svg", _objectSpread(_objectSpread({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), {}, {
    ref: ref,
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 12C0 18.63 5.37 24 12 24C18.63 24 24 18.63 24 12C24 5.37 18.63 0 12 0C5.37 0 0 5.37 0 12ZM16.935 7.935C17.205 7.665 17.58 7.5 18 7.5C18.825 7.5 19.5 8.175 19.5 9C19.5 9.42 19.335 9.795 19.065 10.065L11.565 17.565C11.295 17.835 10.92 18 10.5 18C10.08 18 9.705 17.835 9.435 17.565L4.935 13.065C4.665 12.795 4.5 12.42 4.5 12C4.5 11.175 5.175 10.5 6 10.5C6.42 10.5 6.795 10.665 7.065 10.935L10.5 14.385L16.935 7.935Z",
      fill: color
    })
  }));
});
CheckIcon.displayName = "TablePricing.CheckIcon";